export const enum Currency {
  EUR = 'EUR',
  USD = 'USD',
}
